import { Component, Inject, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceActionDialogData, DeviceActionDialogResult } from '../../../Interfaces/device-action-dialog.interface';


@Component({
  selector: 'app-device-action-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    TranslateModule,
  ],
  templateUrl: './device-action-dialog.component.html',
  styleUrls: ['./device-action-dialog.component.scss', '../../../../../../assets/theme/cutom/_av-dialog.scss'],
})
export class DeviceActionDialogComponent {
  private readonly _fb = inject(FormBuilder);

  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DeviceActionDialogComponent, DeviceActionDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: DeviceActionDialogData
  ) {
    this.form = this.buildForm();
  }

  private buildForm(): FormGroup {
    if (this.data.action === 'wipe') {
      return this._fb.nonNullable.group({
        keepEnrollmentData: [true],
        keepUserData: [true],
        macOsUnlockCode: [''],
      });
    }
    if (this.data.action === 'freshStart') {
      return this._fb.nonNullable.group({
        keepUserData: [true],
      });
    }
    return this._fb.nonNullable.group({});
  }

  get isWipe(): boolean {
    return this.data.action === 'wipe';
  }

  get isFreshStart(): boolean {
    return this.data.action === 'freshStart';
  }

  onCancel(): void {
    this.dialogRef.close(undefined);
  }

  onSubmit(): void {
    if (this.data.action === 'wipe') {
      const v = this.form.value;
      this.dialogRef.close({
        keepEnrollmentData: v.keepEnrollmentData ?? true,
        keepUserData: v.keepUserData ?? true,
        macOsUnlockCode: v.macOsUnlockCode?.trim() || undefined,
      });
    } else if (this.data.action === 'freshStart') {
      const v = this.form.value;
      this.dialogRef.close({
        keepUserData: v.keepUserData ?? true,
      });
    }
  }
}
